<template>
  <div class="jr-list">
    <template v-for="(job, i) in jobs">
      <job-ad-card
        v-if="job && job._id && job.is_ad"
        :key="`JobRelatedItem-Ad-${job._id}`"
        :company="job.company"
        :job="job"
        :observer="observerObj"
        :is-interact="isInteraction(job._id)"
        :tracking-params="trackingParams"
        :session-id="biddingSession"
        :request-id="requestId"
        :bidding-id="biddingId"
        :source="source"
        :position="i"
      />
      <job-card
        v-else-if="job && job._id"
        :key="`Job${listType}Item-${job._id}`"
        :company="job.company"
        :job="job"
        :observer="observerObj"
        :is-interact="isInteraction(job._id)"
        :session-id="sessionId"
        :source="source"
        :position="i"
      />
    </template>
  </div>
</template>

<script>
import ListMixin from '../../mixins/list'

export default {
  mixins: [ListMixin],
  props: {
    listType: {
      default: 'Related',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.jr-list {
  @apply w-full px-2;
}

>>> .jc {
  @apply mx-auto mb-4;
}

@screen desktop {
  .jr-list {
    @apply px-5;
  }
}
</style>
